<script setup lang="ts">
/** [#e03fdbc2] Услуга: открытие своего Apple Business Manager и корпоративной почты. */
import { ArrowRight, Check, ChevronRight } from 'lucide-vue-next';
import ContactBlock from './landing/ContactBlock.vue';
import PublicShell from './landing/PublicShell.vue';
import { usePublicPage } from './landing/usePublicPage';

const { copy, more, to } = usePublicPage();
</script>

<template>
  <PublicShell>
    <main>
      <div class="lp-wrap lp-page lp-page--top">
        <nav class="lp-crumbs" :aria-label="copy.articles.home">
          <RouterLink :to="to('/')">{{ copy.articles.home }}</RouterLink>
          <ChevronRight :size="14" /><span>ABM</span>
        </nav>
        <header class="lp-page-head">
          <h1>{{ more.abm.title }}</h1>
          <p>{{ more.abm.sub }}</p>
        </header>
        <a href="#contact" class="lp-btn lp-btn--primary">{{ more.abm.cta }}<ArrowRight :size="17" /></a>
      </div>
      <section class="lp-section lp-section--tint">
        <div class="lp-wrap">
          <header class="lp-head"><h2>{{ more.abm.whyTitle }}</h2></header>
          <ul class="lp-three">
            <li v-for="w in more.abm.why" :key="w.title" class="lp-card"><span class="lp-glyph"><Check :size="22" /></span><h3>{{ w.title }}</h3><p>{{ w.text }}</p></li>
          </ul>
        </div>
      </section>
      <section class="lp-section lp-wrap lp-narrow">
        <header class="lp-head"><h2>{{ more.abm.stepsTitle }}</h2></header>
        <ol class="lp-list">
          <li v-for="(s, i) in more.abm.steps" :key="s.title" class="lp-row lp-row--static">
            <span class="lp-num">{{ i + 1 }}</span>
            <div class="lp-grow"><h3>{{ s.title }}</h3><p>{{ s.text }}</p></div>
          </li>
        </ol>
        <div class="lp-pair">
          <div class="lp-card"><h3>{{ more.abm.mailTitle }}</h3><p>{{ more.abm.mailText }}</p></div>
          <div class="lp-card"><h3>{{ more.abm.priceTitle }}</h3><p>{{ more.abm.priceText }}</p></div>
        </div>
      </section>
      <ContactBlock :title="more.abm.cta" :sub="more.abm.priceText" :button="more.abm.cta" />
    </main>
  </PublicShell>
</template>
